var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGlobalMap = function SvgGlobalMap(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37,
    height: 46,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinejoin: "round",
    strokeWidth: 1.809,
    clipPath: "url(#global-map_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#827127",
    strokeLinecap: "round",
    d: "M7.44 14.085C3.492 17.197.958 21.977.958 27.342c0 9.373 7.708 16.973 17.214 16.973s17.214-7.6 17.214-16.973c0-5.374-2.535-10.145-6.484-13.257"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#212121",
    d: "M18.17.942c-4.486 0-8.608 3.923-8.608 8.487 0 6.515 6.446 7.986 8.607 15.086 2.162-7.1 8.607-8.57 8.607-15.086 0-4.564-4.122-8.487-8.607-8.487Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#827127",
    d: "M18.16 6.603c-1.587 0-2.878 1.263-2.878 2.819s1.291 2.82 2.879 2.82c1.587 0 2.878-1.264 2.878-2.82s-1.29-2.82-2.878-2.82ZM9.564 28.29h2.868l2.87 2.828v1.886l-1.913 1.886v.942l-.957.943v1.886l-.956.943-1.912-1.886v-4.714L7.65 31.118v-.943zM2.869 19.8l1.912 1.887h.957l2.869 3.771h.956l.956-.943v-.943l1.913-1.885h1.912M30.602 39.083V33l-1.913-1.886h-3.825v-2.857l1.913-1.858h4.781l3.625 3.546M34.953 23.573h-4.351l-.957-.943h-2.869v-1.886l1.913-1.886h4.38"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "global-map_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h36.34v45.26H0z"
  })))));
};
export default SvgGlobalMap;